import React, { useState } from 'react';
import LineItem from './ReturnLineItem.jsx';

const OrderDetails = ({ order, onSubmit }) => {
  const [confirm, setConfirm] = useState(false);
  const [items, setItems] = useState({});

  const getReturnedItems = () => {
    return Object.keys(items).filter(k =>  items[k].type);
  }

  const handleItemChange = ({ item, ...data }) => {
    setItems({
      ...items,
      [item.variant_id]: {
        ...(items[item.variant_id] ? items[item.variant_id] : {}),
        ...data
      }
    });
  }

  const submit = () => {
    onSubmit(items);
  }

  return (
    <div className="returns-items">
      <h1>{`${confirm ? 'Confirm' : 'Select'}`} Items</h1>
      {confirm && (
        <div>
          <p>Please ensure all exchanges show correct new size in drop down menu.</p>
          <p>Please note if you have requested a refund, an AUD $7.95 shipping fee will be deducted from your refund.</p>
        </div>
      )}
      <br />
      { order.line_items.filter(item => confirm ? !!items[item.id] : true).map(item => <LineItem key={item.id} item={item} onChange={handleItemChange} />)}
      <br />
      {(getReturnedItems().length > 0 && !confirm) && (
        <div className="tb-btn" onClick={() => setConfirm(true)}>Next</div>
      )}
      { confirm && (
        <div>
          <div className="tb-btn outline" style={{ marginRight: "5px" }} onClick={() => setConfirm(false)}>Back</div>
          <div className="tb-btn" style={{ marginLeft: "5px" }} onClick={submit}>Submit</div>
        </div>
      )}
    </div>
  )
};

export default OrderDetails;